import { render, staticRenderFns } from "./PredictionChartsMonth.vue?vue&type=template&id=6ef0f0ae&"
import script from "./PredictionChartsMonth.vue?vue&type=script&lang=js&"
export * from "./PredictionChartsMonth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports